import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import dayjs from 'dayjs';
import SVG from 'react-inlinesvg';
import cn from 'classnames';

import Tooltip from '../shared/Tooltip';

import '../../../stylesheets/shared/components/DayPicker.postcss';
import tooltipSelectTheme from '../shared/Tooltip-select.module.postcss';
import defaultStyles from './DateFilter.module.postcss';

function DateFilter({ onChange, selectedDay: initialSelectedDay, placeholder, theme, ariaLabel }) {
  const styles = theme || defaultStyles;
  const [selectedDay, setSelectedDay] = useState(initialSelectedDay || null);

  useEffect(() => {
    setSelectedDay(initialSelectedDay);
  }, [initialSelectedDay]);

  const onClear = (e) => {
    e.stopPropagation();
    setSelectedDay(null);
    onChange(null);
  };

  const onDayClick = (day, { disabled }) => {
    if (disabled) return;
    setSelectedDay(day);
    onChange(day);
  };

  const disabledDays = (day) => {
    return day < dayjs().startOf('day');
  };

  return (
    <Tooltip
      placement='bottom-start'
      hideArrow
      triggerOnClick
      theme={tooltipSelectTheme}
      offsetValue={10}
      content={(
        <div className={styles.DateFilter_Tooltip}>
          <DayPicker
            className={styles.DayPicker}
            onDayClick={onDayClick}
            selectedDays={selectedDay}
            disabledDays={disabledDays}
          />
        </div>
      )}
    >
      <div
        role='button'
        aria-label={ariaLabel || placeholder || 'Choose date'}
        tabIndex={0}
        className={cn(styles.DateFilter, {
          [styles.DateFilter__selected]: selectedDay,
        })}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.target.click(); } }}
      >
        <span>
          { !selectedDay &&
            <span className={styles.DateFilter_Placeholder}>{ placeholder || 'All Dates'}</span>
          }
          { selectedDay &&
            <span className={styles.DateFilter_Label}>Events on {dayjs(selectedDay).format('M/D/YY')}</span>
          }
        </span>
        { selectedDay &&
          <button
            type='button'
            onClick={onClear}
            className={styles.DateFilter_CloseIcon}
            aria-label="Clear date"
          >
            <SVG src='/static/images/icons/dropdown-close.svg' />
          </button>
        }
        <div className={styles.DateFilter_Icon}>
          <SVG src='/static/images/icons/dropdown-icon.svg' />
        </div>
      </div>
    </Tooltip>
  );
}

DateFilter.propTypes = {
  onChange: PropTypes.func,
  selectedDay: PropTypes.instanceOf(Date),
};

export default DateFilter;
